export function isPrivateLanHost(hostname) {
  if (!hostname) return false;
  const h = String(hostname).toLowerCase();
  if (/^192\.168\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
  if (/^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
  if (/^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(h)) return true;
  return false;
}

export function getLoopbackApiBase() {
  const envUrl = process.env.VUE_APP_API_URL || "http://localhost:3000";
  try {
    const api = new URL(envUrl);
    if (api.hostname === "localhost" || api.hostname === "127.0.0.1") {
      api.hostname = "localhost";
      return api.origin;
    }
    return api.origin;
  } catch {
    return "http://localhost:3000";
  }
}

export function getLoopbackFrontendOrigin() {
  if (typeof window === "undefined") return "http://localhost:8080";
  const port = window.location.port;
  const protocol = window.location.protocol === "https:" ? "https:" : "http:";
  return port ? `${protocol}//localhost:${port}` : `${protocol}//localhost`;
}

export function getApiBase() {
  const envUrl = process.env.VUE_APP_API_URL || "";
  if (typeof window === "undefined") return envUrl;

  const pageHost = window.location.hostname;
  if (pageHost === "localhost" || pageHost === "127.0.0.1") {
    return envUrl;
  }

  if (!envUrl) return window.location.origin;

  try {
    const api = new URL(envUrl);
    if (api.hostname === "localhost" || api.hostname === "127.0.0.1") {
      api.hostname = pageHost;
      return api.origin;
    }
  } catch {
    /* keep env */
  }

  return envUrl;
}
